<template>
  <div>
    <div id="bridgerpay-container"></div>
  </div>
</template>

<script lang="ts">
import { PaymentApi } from "@/service/PaymentApi";
import { customGlobalError } from "@/helpers/errorHelper";
import { SaleApi } from "@/service/SaleApi";
import { GlobalErrors } from "@/enum/constants";
import { CreateBridgerPaySessionRequest } from "models";
import { defineComponent } from "vue";
import { AxiosError } from "axios";
import { buildPaymentError } from "@/helpers/paymentErrorHelper";
import { ErrorResponse } from "@/custom-models/errorResponse";

export default defineComponent({
  name: "BridgerPay",
  props: ["data", "saleId"],
  data() {
    return {
      iframeUrl: "",
      amount:0,
      currencyCode:"",
      cashierKey:"",
      cashierToken:""
    };
  },
  methods: {
    async bridgerPayDepositListener(event: any) {
      let operationId = this.cashierToken
      if(event.detail?.token){
        operationId = event.detail.token
      }
      window.removeEventListener(`[bp][cashier:${this.cashierKey}]:deposit`, this.bridgerPayDepositListener);
      if (event instanceof CustomEvent && event.detail.type === "declined") {
        const error: ErrorResponse = {
          timestamp: Date.now(),
          status: GlobalErrors.ERROR_401,
          message: this.$t("pay_declined")
        };
        const paymentError = buildPaymentError(error);
        return this.$emit("paymentExecuted", paymentError);
      }
      const request = {
            saleId: this.saleId,
            storeCard: true,
            operationId: operationId,
          };
      try {
        await SaleApi.authorize(request);
        this.$emit("paymentExecuted", { success: true });
      } catch (error:unknown) {
        const axiosError = error as AxiosError;
        const paymentError = buildPaymentError(axiosError?.response?.data as ErrorResponse);
        return this.$emit("paymentExecuted", paymentError);
      }
    }
  },
  async mounted() {
    this.amount = this.data.amountData.grossAmount
    this.currencyCode = this.data.amountData.currencyCode

    const payload:CreateBridgerPaySessionRequest = {
        saleId: this.saleId,
        currencyCode: this.currencyCode,
        amount: this.amount,
    }
    const response = await PaymentApi.generateSessionBridgerPay(payload);
    this.cashierKey = response.data.key;
    this.cashierToken = response.data.token;

    const script = document.createElement("script");
    script.src = "https://checkout.bridgerpay.com/v2/launcher";
    script.setAttribute("data-cashier-key", this.cashierKey);
    script.setAttribute("data-cashier-token", this.cashierToken);

    window.addEventListener(`[bp][cashier:${this.cashierKey}]:deposit`, this.bridgerPayDepositListener);

    const container = document.getElementById("bridgerpay-container");
    container!.appendChild(script);

  },
  beforeUnmount(){
    window.removeEventListener(`[bp][cashier:${this.cashierKey}]:deposit`, this.bridgerPayDepositListener);
  }
});
</script>
